import { useIntl } from "react-intl";

const PasswordPolicies = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.password-policies.title",
            defaultMessage: "Password policies"
        }),
        body: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.password-policies.body",
            defaultMessage:
                "Password policies help ensure best practices for user-created passwords in Atlassian cloud products. This helps reduce the risk of security breaches."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
        </div>
    );
};

export default PasswordPolicies;
